import Balance from "./Balance";
import Stack from "./Stack";
import SubmissionCRUD from "./SubmissionCRUD";
import TransactionCRUD from "./TransactionCRUD";
import LayoutWithNav from "./LayoutWithNav";
import PageHeader from "./PageHeader";
import { HomeIcon } from "lucide-react";
import { useUserContext, useDataContext } from "../contexts";
import { ADMIN } from "../constants";
import { SelectField } from "./Form";
import { useState } from "react";

export default function HomePage() {
  const { user } = useUserContext();
  const { memberUsers, getMemberUserById } = useDataContext();

  const noMemberUsers = memberUsers.length === 0;

  const [selectedUserId, setSelectedUserId] = useState(
    user.profileType === ADMIN
      ? noMemberUsers
        ? null
        : memberUsers[0].id
      : user.id
  );

  const userOptions = memberUsers.map((member) => ({
    name: member.name,
    value: member.id,
  }));

  const selectedUser = selectedUserId
    ? getMemberUserById(selectedUserId)
    : null;

  if (user.profileType === ADMIN && noMemberUsers) {
    return (
      <LayoutWithNav>
        <PageHeader icon={<HomeIcon className="w-6 h-6" />}>Home</PageHeader>
        <div className="p-4 text-center text-gray-500">
          No family members found. Please add some family members first.
        </div>
      </LayoutWithNav>
    );
  }

  return (
    <LayoutWithNav>
      <PageHeader
        icon={<HomeIcon className="w-6 h-6" />}
        rightChildren={
          user.profileType === ADMIN && (
            <SelectField
              id="selectedUser"
              options={userOptions}
              value={selectedUserId}
              onChange={(e) => setSelectedUserId(Number(e.target.value))}
            />
          )
        }
      >
        Home
      </PageHeader>
      <Stack>
        <SubmissionCRUD user={selectedUser} />
        <TransactionCRUD user={selectedUser} />
        <Balance user={selectedUser} />
      </Stack>
    </LayoutWithNav>
  );
}
